import { render } from "./payment-form.vue?vue&type=template&id=2767277b&scoped=true"
import script from "./payment-form.vue?vue&type=script&lang=js"
export * from "./payment-form.vue?vue&type=script&lang=js"

import "./payment-form.vue?vue&type=style&index=0&id=2767277b&lang=scss&scoped=true"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2767277b"]])

export default __exports__